import { render } from "./404.vue?vue&type=template&id=588422f0"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"
script.render = render

export default script